import type {
  MakeRouteLinkBuilderResult,
  MakeUseTypedNavigateResult,
  MakeUseTypedParamsResult,
} from 'utils/routeLink/makeRouteObject'

import type { RoutesData } from './router'

const StubObject: TSFixMe = {}

type Routes = typeof RoutesData['routes']

/**
 * typedRouting is a utility that provides typed navigation, parameter extraction, and link building for routes.
 * Never use in global scope, like in IIFEs or in the main file.
 * This is a stub object, and the actual implementation is overwritten in 'utils/router/router'.
 * If you have issues with unit tests, add import 'utils/router/router' into test file.
 */
export const typedRouting: {
  useNavigate: () => MakeUseTypedNavigateResult<Routes>
  useParams: MakeUseTypedParamsResult<Routes>
  linkBuilder: MakeRouteLinkBuilderResult<Routes>
} = {
  useNavigate: () => StubObject,
  useParams: StubObject,
  linkBuilder: StubObject,
}
